import { IWorkingTime } from "@hero/shared/models/workingTime";
import { IDayRangeRequest, IUploadStatusResponse } from "@hero/shared/models/workingTimeUploadDay";

export enum WorkingTimeUploadTypes {
    GET_WORKING_TIME_UPLOAD = "GET_WORKING_TIME_UPLOAD",
    GET_WORKING_TIME_UPLOAD_SUCCESS = "GET_WORKING_TIME_UPLOAD_SUCCESS",
    GET_WORKING_TIME_UPLOAD_FAILED = "GET_WORKING_TIME_UPLOAD_FAILED",
}

export interface IWorkingTimeUploadAction {
    type: WorkingTimeUploadTypes;
    range?: IDayRangeRequest;
    status?: IUploadStatusResponse;
    records?: IWorkingTime[];
    error?: any;
}

export const getWorkingTimeUploadInfo = (range: IDayRangeRequest): IWorkingTimeUploadAction => ({
    type: WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD,
    range,
});

export const getWorkingTimeUploadInfoSuccess = (
    status: IUploadStatusResponse,
    records: IWorkingTime[]
): IWorkingTimeUploadAction => ({
    type: WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD_SUCCESS,
    status,
    records,
});

export const getWorkingTimeUploadInfoFailed = (error: any): IWorkingTimeUploadAction => ({
    type: WorkingTimeUploadTypes.GET_WORKING_TIME_UPLOAD_FAILED,
    error,
});
